export const articlesSlider = function() {
    const articlesContainer = document.querySelector('.jsArticlesContainer');
          articlesSlider();

    function articlesSlider() {
        if (!articlesContainer) return;
        const articlesSwiper = new Swiper(articlesContainer, {
            slidesPerView: 1.3,
			centeredSlides: true,
            spaceBetween: 15,
            watchOverflow: true,
            pagination: {
                el: '.articles-slider-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '.articles-slider__next',
                prevEl: '.articles-slider__prev'
            },
			breakpointsInverse: true,
			breakpoints: {
				768: {
					slidesPerView: 2.5,
					slidesPerGroup: 1,
					centeredSlides: false
			   },
			   1024: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					centeredSlides: false
			   }
		   }
		});
    }
}
